import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import styled from 'styled-components';
import { WL_URL } from '../../../settings';

interface IProps {
  data: any;
  channel?: string;
  setSuggestionData: Function;
  setSuggestionOpened: Function;
  setSearchString: Function | undefined;
}

interface IWebinars {
  id: number;
  cover: string;
  is_public: boolean;
  slug: string;
  state: string;
  title: string;
  url: string;
}

interface IGroup {
  id: number;
  name: string;
  url: string;
  slug: string;
}

export default function AutoComplete({ data, channel, setSuggestionData, setSuggestionOpened, setSearchString }: IProps): React.ReactElement {
  const [webinars, setWebinars] = useState<IWebinars[]>([]);
  const [groups, setGroups] = useState<IGroup[]>([]);

  const history = useHistory();

  useEffect(() => {
    setWebinars([
      ...data?.talks
    ])

    setGroups([
      ...data?.groups
    ])
  }, [data])

  const renderWebinarsList = () => {
    return (
      <>
        <li className="list-title">Webinars:</li>
        <WebinarList>
          {webinars.map(({ title, id, slug }) => (
            <a key={`a-${id}`} href="#" onClick={(e) => { e.preventDefault(); history.push(`/${channel}/${slug}`) }} target="blank" >
              <li key={id}>
                {title}
              </li>
            </a>
          ))}
        </WebinarList>
      </>
    )
  }

  const renderGroupsList = (channel?: string) => {
    return (
      <>
        <li className="list-title">Grupos:</li>
        <GroupList>
          {groups.map(({ name, id, url, slug }) => (
            <a key={`a-${id}`} href="#" onClick={(e) => { e.preventDefault(); history.push(`/${channel}/groups/${slug}`) }} target="blank">
              <li key={id}>
                {name}
              </li>
            </a>
          ))}
        </GroupList>
      </>
    )
  }

  const resultNotFound = () => {
    return (
      <span style={{marginBottom: '0', textAlign: 'center'}}>Não encontramos nenhum resultado :(</span>
    )
  }

  const handleOverlayClick = () => {
    setSuggestionOpened(false);
    setSuggestionData([]);
    if (setSearchString !== undefined) {
      setSearchString('');
    }
  }

  return (
    <>
      <Container>
        {groups.length === 0 && webinars.length === 0 ? 
          resultNotFound() : 
          <SuggestionList>
            {groups.length > 0 && renderGroupsList(channel)}
            {webinars.length > 0 && renderWebinarsList()}
          </SuggestionList>
        }
      </Container>
      <Overlay onClick={() => handleOverlayClick()} />
    </>
  )
}

const Overlay = styled.div`
  display: block;
  background-color: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1;

`
const Container = styled.div`
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  position: absolute;
  top: 0;
  margin-top: 72px;
  margin-left: 6px;
  width: 360px;
  border-radius: 16px;
  height: auto;
  max-height: 300px;
  padding: 16px;
  overflow: auto;

  @media only screen and (max-width: 660px){
    top: 70px;
    left: 0px;
  }

  background-color: ${(props) => props.theme.colors.background};

  &::-webkit-scrollbar {
    width: 20px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.border};
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }

  .list-title {
    padding: 0;
    font-weight: 700;

    &:hover {
      color: ${(props) => props.theme.colors.secondary};
    }
  }

  ul {
    padding-left: 8px;
  }

  li {
    color: ${(props) => props.theme.colors.secondary};
    font-weight: 500;
    margin-bottom: 8px;
    &:hover {
      color: ${(props) => props.theme.colors.terciary};
    }
  }
`

const SuggestionList = styled.ul`
  list-style-type: none;
`

const GroupList = styled.ul`
  list-style-type: none;
`

const WebinarList = styled.ul`
  list-style-type: none;
`